import { createDucks } from '@8powers/core/redux';

const { reducer, saga, actions } = createDucks('protocolItem', {
  protocolItem: {
    endpoint: 'protocolItem',
    slices: ['list', 'detail', 'create', 'edit']
  },
  protocol: {
    endpoint: 'protocol',
    slices: ['combo']
  },
  contractItem: {
    endpoint: 'contractItem',
    slices: ['combo']
  }
});

export { saga, actions };
export default reducer;
